import axios from '@/requests';
import { Task, CrontabTask } from "@/store/modules/task/types";

export interface TaskListParam {
    projId: string,
    typeList: string,
}

export interface CreateTaskParam {
    projId: string,
    payload: string,
    type: number,
    uid?: string,
}

export interface TaskListByUidParam {
    projId: string,
    uid: string,
    typeList: string,
}

export interface GetPayloadByTaskId {
    projId: string,
    uid: string,
    taskId: string,
}

export interface UpdateCrontabParam {
    projId: string,
    uid: string,
    taskId: string,
    crontabType: number,
    crontabTime: string,
    intervalTime: number,
}


export const taskAPI = {
    async getOwnTaskListInProjByTypes(taskListParam: TaskListParam) {
        try {
            return await axios.get<Task[]>('/task/getOwnTaskListInProjByTypes', taskListParam)
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async createTask(createTaskParam: CreateTaskParam): Promise<Task> {
        try {
            return await axios.post<Task>("/task/createTask", createTaskParam);
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async downloadSparrowByTaskId(taskId: string, filename: string): Promise<void> {
        try {
            return await axios.download<void>("/download/sparrowById", { "taskId": taskId }, filename);
        }
        catch (err) {
            return Promise.reject(err);
        }
    },
    async getSparrowPathByTaskId(taskId: string): Promise<string> {
        try {
            return await axios.get<string>("/download/getSparrowPathByTaskId", { "taskId": taskId });
        }
        catch (err) {
            return Promise.reject(err);
        }
    },

    async GetTaskListByProjIdAndTargetIdAndTypes(taskListByUidParam: TaskListByUidParam) {
        try {
            return await axios.get<Task[]>('/task/getTaskListByProjIdAndTargetIdAndTypes', taskListByUidParam)
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async GetPayloadByTaskId(getPayloadByTaskId: GetPayloadByTaskId) {
        try {
            return await axios.get<Task>('/task/getPayloadByTaskId', getPayloadByTaskId)
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async GenDownloadLinkForOut(taskId: string): Promise<string> {
        try {
            return await axios.get<string>("/sparrow/genDownloadLinkForOut", { "taskId": taskId });
        }
        catch (err) {
            return Promise.reject(err);
        }
    },
    async GetCrontabTaskList(projId: string, uid: string) {
        try {
            return await axios.get<CrontabTask>('/task/getCrontabTaskList', { "projId": projId, "uid": uid })
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async CreateCrontabTask(createCrontabParam: UpdateCrontabParam) {
        try {
            return await axios.get<CrontabTask>('/task/updateTaskToCrontabTask', createCrontabParam)
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async UpdateCrontbTaskStatus(updateCrontabParam: UpdateCrontabParam) {
        try {
            return await axios.get<CrontabTask>('/task/updateCrontbTaskStatus', updateCrontabParam)
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async DeleteCrontbTaskStatus(projId: string, uid: string, taskId: string) {
        try {
            return await axios.get<CrontabTask>('/task/deleteCrontbTaskStatus', { "projId": projId, "uid": uid, "taskId": taskId })
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async CheckIsCrontabExistByTaskId(projId: string, uid: string, taskId: string) {
        try {
            return await axios.get<boolean>('/task/checkIsCrontabExistByTaskId', { "projId": projId, "uid": uid, "taskId": taskId })
        } catch (err) {
            return Promise.reject(err);
        }
    },

    // checkIsCrontabExistByTaskId
}